import React, { forwardRef } from 'react';
import cn from 'classnames';
import styles from './styles.module.css';
const TYPE_MAP = {
    p: 'padding',
    m: 'margin',
};
const DIR_MAP = {
    l: 'left',
    r: 'right',
    t: 'top',
    b: 'bottom',
};
function generateClassName({ p, pr, pl, pt, pb, px, py, m, ml, mr, mt, mb, mx, my, gap, inline, className, }) {
    const classes = new Set();
    const spacings = {
        p,
        pr: pr !== null && pr !== void 0 ? pr : px,
        pl: pl !== null && pl !== void 0 ? pl : px,
        pt: pt !== null && pt !== void 0 ? pt : py,
        pb: pb !== null && pb !== void 0 ? pb : py,
        m,
        ml: ml !== null && ml !== void 0 ? ml : mx,
        mr: mr !== null && mr !== void 0 ? mr : mx,
        mt: mt !== null && mt !== void 0 ? mt : my,
        mb: mb !== null && mb !== void 0 ? mb : my,
    };
    for (const key in spacings) {
        const property = key;
        const value = spacings[property];
        if (!value)
            continue;
        const [type, dir] = key.split('');
        const parts = [value];
        if (dir === 'l' || dir === 'r' || dir === 't' || dir === 'b') {
            parts.unshift(DIR_MAP[dir]);
        }
        if (type === 'p' || type === 'm') {
            parts.unshift(TYPE_MAP[type]);
        }
        classes.add(styles[parts.join('-')]);
    }
    if (gap) {
        classes.add(styles[`gap-${gap}`]);
    }
    if (inline) {
        classes.add(styles.inline);
    }
    return cn(...classes, styles.box, className);
}
function generateStyles({ flex, flexDirection, flexGrow, flexWrap, flexShrink, alignContent, alignItems, alignSelf, justifyContent, style, }) {
    return omitUndefined({
        flex,
        flexDirection,
        flexGrow,
        flexWrap,
        flexShrink,
        alignContent,
        alignItems,
        alignSelf,
        justifyContent,
        ...style,
    });
}
export function useBox(props) {
    return { className: generateClassName(props), style: generateStyles(props) };
}
function omitUndefined(obj) {
    const result = {};
    for (let key in obj) {
        if (obj[key] === undefined)
            continue;
        result[key] = obj[key];
    }
    return result;
}
const BoxWithRef = forwardRef((props, ref) => {
    const { children, p, pr, pl, pt, pb, px, py, m, ml, mr, mt, mb, mx, my, gap, inline, className, flex, flexDirection, flexGrow, flexWrap, flexShrink, alignContent, alignItems, alignSelf, justifyContent, style, Component, ...rest } = props;
    const boxProps = useBox(props);
    const Container = Component || 'div';
    return (React.createElement(Container, { ref: ref, ...boxProps, ...rest }, children));
});
export const Box = BoxWithRef;
